export default {"commitHash": "307e501", "version": "3.7.0-4-g307e501"};
